import { render, staticRenderFns } from "./targetclassification.vue?vue&type=template&id=33f9f482&scoped=true"
import script from "./targetclassification.vue?vue&type=script&lang=js"
export * from "./targetclassification.vue?vue&type=script&lang=js"
import style0 from "./targetclassification.vue?vue&type=style&index=0&id=33f9f482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9f482",
  null
  
)

export default component.exports